
import CheckBox from '@/components/utils/CheckBox.vue';
import CheckBoxGroup from '@/components/utils/CheckBoxGroup.vue';
import Popup from '@/components/utils/Popup.vue';
import RadioGroup from '@/components/utils/RadioGroup.vue';
import RadioItem from '@/components/utils/RadioItem.vue';
import Select from '@/components/utils/Select.vue';
import SelectOption from '@/components/utils/SelectOption.vue';
import { QuestionnaireQuestion, QuestionnarieResult, zawaroom } from '@/utils/models';
import Component from 'vue-class-component';
import { Emit, Prop, Vue } from 'vue-property-decorator';
import { v4 as uuid } from 'uuid';
import LoadingPopup from '../room/LoadingPopup.vue';

type Question = QuestionnaireQuestion & {
  notSelectedError: boolean;
  selectedValues: (string | undefined)[];
};

@Component({
  components: {
    Popup,
    Select,
    SelectOption,
    RadioGroup,
    RadioItem,
    CheckBoxGroup,
    CheckBox,
    LoadingPopup,
  },
})
export default class QuestionnairePopup extends Vue {
  @Prop() isVisible!: boolean;
  @Emit('onFinish')
  onFinish() {}

  questions: Question[] | null = null;

  async mounted() {
    this.questions = (await this.axios.get<QuestionnaireQuestion[]>('/zawa-data/questionnaire')).data.map((q) => ({
      ...q,
      notSelectedError: false,
      selectedValues: [],
    }));
  }

  onSelectChange(value: string, questionId: string) {
    const q = this.questions?.find((q) => q.id === questionId);
    if (!q) throw new Error('該当の選択肢は見つかりませんでした');
    q.selectedValues = [value];
  }

  onCheckChange(value: string, questionId: string) {
    const q = this.questions?.find((q) => q.id === questionId);
    if (!q) throw new Error('該当の選択肢は見つかりませんでした');
    if (q.selectedValues.includes(value)) {
      q.selectedValues = q.selectedValues.filter((v) => v !== value);
    } else {
      q.selectedValues = [...q.selectedValues, value];
    }
  }

  onRadioChange(value: string, questionId: string) {
    const q = this.questions?.find((q) => q.id === questionId);
    if (!q) throw new Error('該当の選択肢は見つかりませんでした');
    q.selectedValues = [value];
  }

  async answerQuestionnaire() {
    if (!this.questions) {
      return;
    }
    for (const q of this.questions) {
      q.notSelectedError = q.selectedValues.length === 0 || q.selectedValues[0] == undefined;
      if (q.notSelectedError) return;
    }
    const result: QuestionnarieResult = {
      id: uuid(),
      results: this.questions.map((q) => ({
        questionId: q.id,
        options: q.options.filter((o) => q.selectedValues.includes(o.value)),
      })),
    };
    const callbackResult = await zawaroom.dataService?.emitQuestionnaireResult(result);
    if (typeof callbackResult === 'string') {
      this.$toast.error(callbackResult);
    } else {
      this.onFinish();
    }
  }
}
